var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_object_class = function () {
    OCS.Viewer.Classes.OlObject = new Class(OCS.Viewer.Interfaces.OlObject);
};
OCS.Viewer.Functions.define_ol_object_class();